// Base service name
export const SERVICE_NAME = "LOADING_SERVICE";
